import _ from 'lodash'
import { Address, zeroAddress } from 'viem'

// INFO: BIT SETS
export const getBitSet = (bitSet: bigint | number | string): number[] =>
  BigInt(bitSet)
    .toString(2)
    .split('')
    .map(Number)
    .reverse()
    .map((bit, index) => (bit ? index : -1))
    .filter((index) => index !== -1)

export const zeroTarget = {
  skipRevert: false,
  addr: zeroAddress,
  value: 0n,
  data: '0x',
} as const

export function notUndefined<TValue>(value: TValue | undefined): value is TValue {
  return value !== undefined
}

export const sumBalancesByCurrency = (
  balances: { currency: string; balance: bigint }[],
): { currency: Address; balance: bigint }[] => {
  return _(balances)
    .groupBy('currency')
    .map((groupedBalances, currency) => ({
      currency: currency as Address,
      balance: BigInt(_.sumBy(groupedBalances, 'balance')),
    }))
    .value()
}
